module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-1400.33ed9068.svg";